<div class="dform-header d-flex justify-content-end">
  <button mat-icon-button (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <div class="d-flex justify-content-center">
    <img src="assets/images/images-status/complete.png" srcset="assets/images/images-status/complete@2x.png 2x,
    assets/images/images-status/complete@3x.png 3x" alt="{{'lbl.no-data' | translate }}" class="img-empty">
  </div>
  <div class="dform-title">
    {{data?.title || 'Title' | translate}}
  </div>
  <!-- Detail -->
  <p class="text-center fs-20" *ngIf="data?.message">{{data?.message || 'Message' | translate}}</p>
  <p class="text-center fs-20" *ngIf="data?.innerHTML" [innerHTML]="data?.innerHTML"></p>
  <!-- <textarea ref-textarea rows="10" cols="70" class="dialog-text-area" [(ngModel)]="confirm" [placeholder]="data?.description"></textarea> -->
  <div *ngIf="data?.description" class="form-group" [class.error]="!confirm && isRequired">
    <div class="form-input-row">
      <textarea ref-textarea rows="5" cols="70" class="dialog-text-area" [(ngModel)]="confirm"
        [placeholder]="data?.description" maxlength="300" (ngModelChange)="ngModelChange()"></textarea>
    </div>
    <div *ngIf="!confirm && isRequired" class="form-remark">
      {{data?.description || 'Title' | translate}} {{ 'validations.not-null' | translate}}
    </div>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-center">
  <button class="btn btn-error btn-md mrr-4" (click)="onCancelConfirm()">
    <!-- Accept Button -->
    {{ data?.closeBtn | translate}}
  </button>
  <button class="btn btn-primary btn-md mrl-4" (click)="onUpdateConfirm()">
    <!-- Error Button -->
    {{ data?.acceptBtn | translate }}
  </button>
</div>